import { NgModule } from '@angular/core';


import './option/types/number/index';
import './option/types/text/index';
import './option/types/afterschool/index';


import './question/types/radio/index';
import './question/types/checkbox/index';
import './question/types/text/index';
import './question/types/table-checkbox/index';
import './question/types/weekly-table/index';
import './question/types/afterschool/index';

import './survey/types/default/index';
import './survey/types/afterschool/index';

@NgModule({
})
export class SurveyClassesModule {}
